<template id="CTAButton">
    <div class="cta-button-container py-4 px-3" :class="[align, {'rounded-border px-3' : cta_border_rounded}]" :style="[cta_border_color? {'border-color': cta_border_color} : '']">
        <div class="cta-heading" v-if="has_heading">
            <h3>{{ heading_text }}</h3>
        </div>
        <div class="cta-description mb-3" v-if="has_description">
            {{ description_text }}
        </div>
        <div class="cta-button">
            <a
                :id="block_id"
                class="btn btn-lg animate__animated animate__infinite"
                :href="cta_link"
                role="button"
                :target="target"
                :class="[
                    {
                        'btn-square': !rounded,
                        'btn-gradient btn-primary': !button_bg_color,
                    },
                    animation,
                ]"
                :style="[
                    button_text_color ? { color: button_text_color } : '',
                    button_bg_color
                        ? { 'background-color': button_bg_color }
                        : '',
                    button_border_color
                        ? { 'border-color': button_border_color }
                        : '',
                ]"
                >{{ text }}</a
            >
        </div>
    </div>
</template>
<script>
import { isMobile, isAndroid, isIOS } from "mobile-device-detect";

export default {
    props: {
        button: {
            required: true,
            default: function () {
                return {};
            },
        },
        block_id: {
            type: String,
            required: true,
            default: "",
        },
        result: {
            type: String,
            required: false,
            default: "",
        },
        post_id: {
            type: Number,
            required: true,
            default: "",
        },
    },
    computed: {
        text: function () {
            return this.button.text || "";
        },
        align: function () {
            return this.button.align || "text-center";
        },
        rounded: function () {
            return Boolean(this.button.rounded);
        },
        has_heading: function () {
            return Boolean(this.button.enable_heading);
        },
        has_description: function () {
            return Boolean(this.button.enable_description);
        },
        heading_text: function () {
            return this.button.heading_text || "";
        },
        description_text: function () {
            return this.button.description_text || "";
        },
        animation: function () {
            return this.button.animation || "";
        },
        target: function () {
            return Boolean(this.button.link_target)? '_blank' : '_self';
        },
        button_bg_color: function () {
            return this.convert_color(this.button.color);
        },
        button_text_color: function () {
            return this.convert_color(this.button.text_color);
        },
        button_border_color: function () {
            return this.convert_color(this.button.border);
        },
        cta_border_color: function () {
            return this.convert_color(this.button.cta_border);
        },
        cta_border_rounded: function () {
            return this.button.cta_border_rounded || false;
        },
        cta_link: function () {
            let params = {link: '', id: this.post_id, block: this.block_id}
            if(!this.isEmpty(this.result)) {
                params.result = this.result
            }
            const web = this.button.link.web
            const ios = this.button.link.ios
            const android = this.button.link.android
            const mobile = this.button.link.mobile
            
            if(
                (this.isEmpty(ios) && this.isEmpty(mobile) && isIOS) || 
                (this.isEmpty(android) && this.isEmpty(mobile) && isAndroid) || 
                !isMobile
            ) {
                params.link = web
            } else if(isIOS) {
                if(this.isEmpty(mobile)) {
                    params.link = ios
                } else {
                    params.link = mobile
                }
            } else if(isAndroid) {
                if(this.isEmpty(mobile)) {
                    params.link = android
                } else {
                    params.link = mobile
                }
            } else if(isMobile) {
                if(!this.isEmpty(mobile)) {
                    params.link = mobile
                } else {
                    params.link = web
                }
            }

            return this.$variables.lead_redirect + '?' + $.param(params);
        },
    },
    methods: {
        convert_color: function (colors, fallback = null) {
            if (typeof colors === "string") {
                return colors;
            }

            return colors && typeof colors.hex !== "undefined"
                ? colors.hex
                : false;
        },
        isEmpty: function(value){
            return (value == null || value === '');
        }
    },
    watch: {},
};
</script>
